'use client';

import { useState, useEffect } from 'react';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Ikke i innebygd iframe (embed-widget på tredjeparts side)
    if (window.self !== window.top) return;
    // Register service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    // Listen for install prompt
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      if (!localStorage.getItem('pwa-dismissed')) {
        setShow(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!show || !deferredPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm bg-stone-900 text-white rounded-2xl p-4 shadow-2xl flex items-center gap-3">
      <div className="flex-1">
        <div className="text-sm font-medium">Installer CoachGuiden</div>
        <div className="text-xs text-stone-400">Raskere tilgang fra hjemskjermen</div>
      </div>
      <button
        onClick={async () => {
          deferredPrompt.prompt();
          await deferredPrompt.userChoice;
          setShow(false);
          setDeferredPrompt(null);
        }}
        className="px-3 py-1.5 bg-white text-stone-900 rounded-lg text-xs font-medium hover:bg-stone-100"
      >
        Installer
      </button>
      <button
        onClick={() => {
          setShow(false);
          localStorage.setItem('pwa-dismissed', '1');
        }}
        className="text-stone-500 hover:text-white text-lg leading-none"
      >
        &times;
      </button>
    </div>
  );
}
